import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "space-y-0.5" }

import {Button} from "@/components/ui/button";
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter, DialogHeader, DialogTitle
  } from "@/components/ui/dialog";
  import {Input} from "@/components/ui/input";
  import TablesService from "@/services/tables/tables.service";
  import {Switch} from "@/components/ui/switch";
  import useEventsBus from "@/utils/eventBus";
  import {Separator} from "@/components/ui/separator";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {onMounted, watch} from "vue";
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MastersEditForm',
  props: {
    object: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props
  const { emit } = useEventsBus();
  let master: any = {};
  const formSchema = toTypedSchema(z.object({
    name: z.string(),
    code: z.string(),
    address: z.string(),
    city: z.string(),
    zip: z.string(),
    province: z.string(),
    state: z.string(),
    enabled: z.boolean().default(true)
  }))
  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })

  watch(values, (newFormData) => {
    master = newFormData;
  });

  const onSubmit = handleSubmit(async () => {
    let res;
    if (!props.object.id) {
      res = await TablesService.createRecord(master, props.entity);
    } else {
      res = await TablesService.updateRecord(master, props.entity);
    }
    if (res != undefined) {
      emit('update_'+props.entity, res.data);
    }
  })

  watch(() => props.open, async(_, newValue) => {
    if (newValue === false) {
      if (props.object.id) {
        setValues(props.object);
      }
    }
  },{ immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              (!props.object.id)
                ? (_openBlock(), _createBlock(_unref(DialogTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(DialogTitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.edit')), 1)
                    ]),
                    _: 1
                  })),
              _createElementVNode("form", {
                onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "mt-3"
              }, [
                _createVNode(_unref(FormField), { name: "code" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.code')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.code')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "name" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.name')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Separator), { class: "my-1" }),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(FormField), { name: "address" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.address')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.address')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "city" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.city')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.city')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(FormField), { name: "zip" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.zip')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.zip')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "province" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.province')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.province')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "state" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.state')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.state')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Separator), { class: "my-1" }),
                _createVNode(_unref(FormField), { name: "enabled" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_unref(FormItem), { class: "flex flex-row items-center gap-4 p-4" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_unref(FormLabel), { class: "text-base" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('table.enabled')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Switch), {
                              checked: value,
                              "onUpdate:checked": handleChange
                            }, null, 8, ["checked", "onUpdate:checked"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogFooter), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})